import React from "react";
import Modal from "react-bootstrap/Modal";
import { AiOutlineCreditCard, AiOutlineBank, AiOutlineThunderbolt, AiOutlineClockCircle } from "react-icons/ai";
import { useTranslations } from "../../translations";

/**
 * Modal de elección de método de pago. Dos opciones al mismo nivel:
 * tarjeta (Stripe, inmediato) y Pago Móvil/Transferencia (Venezuela, al verificar).
 */
const PaymentMethodModal = ({ show, onHide, planLabel, priceLabel, onSelectCard, onSelectLocal }) => {
  const { t } = useTranslations();

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="pay-modal">
      <Modal.Header closeButton className="border-0 pb-0" />
      <Modal.Body className="px-4 pb-4 pt-0">
        <div className="text-center mb-4">
          <h4 className="mb-1 pay-modal-title">{t("choosePaymentMethod")}</h4>
          {planLabel && (
            <p className="text-muted mb-0 small">
              {planLabel} · <span className="fw-semibold">{priceLabel}</span>
            </p>
          )}
        </div>

        <div className="d-flex flex-column flex-sm-row gap-3">
          <button type="button" className="pay-option" onClick={onSelectCard}>
            <span className="pay-option-chip">
              <AiOutlineCreditCard size={26} />
            </span>
            <span className="pay-option-title">{t("payCardTitle")}</span>
            <span className="pay-option-desc">{t("payCardDesc")}</span>
            <span className="pay-option-badge pay-badge-instant">
              <AiOutlineThunderbolt size={13} /> {t("payCardBadge")}
            </span>
          </button>

          <button type="button" className="pay-option" onClick={onSelectLocal}>
            <span className="pay-option-chip">
              <AiOutlineBank size={26} />
            </span>
            <span className="pay-option-title">{t("payLocalTitle")}</span>
            <span className="pay-option-desc">{t("payLocalDesc")}</span>
            <span className="pay-option-badge pay-badge-manual">
              <AiOutlineClockCircle size={13} /> {t("payLocalBadge")}
            </span>
          </button>
        </div>
      </Modal.Body>

      <style>{`
        .pay-modal { border: none; border-radius: 20px; overflow: hidden; }
        .pay-modal-title { color: var(--plum-bg, #3d1a33); font-weight: 700; }
        .pay-option {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          text-align: left;
          background: #fff;
          border: 1.5px solid rgba(0,0,0,0.08);
          border-radius: 16px;
          padding: 20px 18px;
          cursor: pointer;
          transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease;
        }
        .pay-option:hover {
          border-color: var(--pink-bright, #eb2178);
          transform: translateY(-4px);
          box-shadow: 0 12px 28px rgba(235,33,120,0.15);
        }
        .pay-option:focus-visible {
          outline: 3px solid rgba(235,33,120,0.35);
          outline-offset: 2px;
        }
        .pay-option-chip {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 48px; height: 48px;
          border-radius: 14px;
          color: #fff;
          background: linear-gradient(135deg, var(--pink-bright, #eb2178), #ff9d2e);
          margin-bottom: 4px;
        }
        .pay-option-title { font-weight: 700; font-size: 1.05rem; color: var(--plum-bg, #3d1a33); }
        .pay-option-desc { font-size: .85rem; color: #6b6b6b; line-height: 1.35; }
        .pay-option-badge {
          margin-top: 6px;
          display: inline-flex; align-items: center; gap: 4px;
          font-size: .72rem; font-weight: 600;
          padding: 3px 10px; border-radius: 999px;
        }
        .pay-badge-instant { background: rgba(0,184,148,0.12); color: #00916e; }
        .pay-badge-manual { background: rgba(108,92,231,0.12); color: #5b4bd0; }
        @media (prefers-reduced-motion: reduce) {
          .pay-option, .pay-option:hover { transition: none; transform: none; }
        }
      `}</style>
    </Modal>
  );
};

export default PaymentMethodModal;
